import { readableStepName, escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../../components/DetailItem/DetailItem';
import {StakeholdersDetails} from "../../components/StakeholdersDetails/StakeholdersDetails";
import React from "react";

export const DataCustodyReceivedStepModel = (step) => {
    return (
    <>
      <p className='details-title'>
        <b>
          { readableStepName(step['@type']) }
        </b>
      </p>

      <DetailItem title='Title' content={escapeEmptyDetail(step.title)} />
      <DetailItem title='Description' content={escapeEmptyDetail(step.description)} />
        <StakeholdersDetails newStakeholders={step.newCustodians} oldStakeholders={step.oldCustodians} />
        <DetailItem title='Schema' content={escapeEmptyDetail(step.schema)} />
    </>
  );
};
